import { Component, OnInit, OnDestroy } from '@angular/core';
import { AppComponent } from '../app.component';
import { Observable, Subscription } from 'rxjs';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Store } from '@ngrx/store';
import { AppState } from '../store/app.reducer';

@Component({
  selector: 'app-menu',
  template: `
    <div id="logolink" class="layout-menu-logo" style="cursor: pointer; outline: none;" routerLink="/home/sites">
			<img class="mb-2" id="app-logo" [src]="getMenuTheme() === 'dim' ? './assets/images/logos/cameconnect-main.png' : './assets/images/logos/cameconnect-whiteblack.png'" alt="Came Connect logo">
		</div>
    <ul class="layout-menu">
			<li app-menuitem *ngFor="let item of model; let i = index;" [item]="item" [index]="i" [root]="true"></li>
		</ul>
		<div class="fixed bottom-0 flex align-items-end justify-content-between w-full mb-3">
			<div class="flex font-normal text-sm font-medium pl-3" [class]="getMenuTheme() === 'dim' ? 'text-300' : 'text-900'">R: {{ this.version }}</div>
			<div class="flex pr-3"><img [src]="getMenuTheme() === 'dim' ? 'assets/images/logos/CAME-A_alpha_white_blue.png' : 'assets/images/logos/CAME-A_alpha_white.png'" alt="Logo" style="height:1.5rem;"/></div>
		</div>
  `,
  styles:
	`
		img {
			-webkit-user-drag: none;
			user-drag: none;
		}
	`
})
export class AppMenuComponent implements OnInit, OnDestroy {
  /**
   * Local reference to the features configuration (for the html file)
   */
  /**
   * Feature list observable referencing to the device store
   */
  featuresSel$: Observable<string[]> = new Observable<string[]>();
  featuresSub: Subscription | undefined;

  model!: any[];

  version: string;

  constructor(
    public app: AppComponent,
    private translate: TranslateService,
    private store: Store<AppState>
  ) {
    this.setupMenuModel();
  }

  ngOnInit() {
    this.featuresSub = this.featuresSel$.subscribe((payload) => this.setItemVisibility(payload));

    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      // Subscribe to the languageChangeToggle, so the translate language have already been set into translate service object
      this.computeTranslation();
    });
  }

  ngOnDestroy(): void {
    if(this.featuresSub) {
      this.featuresSub?.unsubscribe();
    }
  }

  getMenuTheme(): string {
		return this.app.menuTheme;
	}

  setupMenuModel(): void {
    const featsPath = "features/";
    this.model = [/*{
      stringId: 'MENU',
      label: '',
      items: []},*/ //TODOINSERT
    ];
    this.computeTranslation();
    this.initializeItemVisibility();
  }

  /**
   * Computes the translation of each label of this.model
   */
  computeTranslation(): void {
    this.model.forEach(segment => {
      segment.label = this.translate.instant(segment.stringId);
      segment.items.forEach((row: any) => {
        row.label = this.translate.instant(row.stringId);
      })
    })
  }

  /**
   * Initializes all the item visibility to false
   */
  initializeItemVisibility(): void {
    //TODOINSERT
    /*for (const item in Feature) { // item could be SYSTEM_INFO, DATE_TIME, but also 0, 1,...
      if (isNaN(Number(item))) { // Discard numeric keys
        // Find first object whose value matches condition
        this.model.forEach(m => {
          const first = m.items.find((obj: any) => {
            return obj.feature === Feature[item];
          });
          if(first) {
            first.visible = false;
          }
        });
      }
    }*/
  }

  /**
   * Enables or disables the visibility of each item of the sidebar
   * @param featuresArray Array of features coming from device
   */
  setItemVisibility(featuresArray: string[]): void {
    //TODOINSERT
    /*
     * Iterates over all the itemVisibility map:
     * Check if the feature is present into the featuresArray
     * -> If found, set it to true
     * -> Else set it to false
     */
    /*this.model.forEach(m => {
      m.items.forEach(function (value: any) {
        const key = Feature[value.feature];   // SYSTEM_INFO | DATE_TIME | NETWORK | ...
        const featureProp: FeatureProperty = featuresConfiguration[key as keyof typeof Feature];
        if (featuresArray.includes(featureProp.featureId)) {
          value.visible = true;
        }
        else {
          value.visible = false;
        }
      });
    });*/
  }
}
